import React, { memo, useCallback } from "react";
import { PencilOutlineIcon } from "modules/icons";
import colors from "app/colors";
import CircularIconButton from "modules/_shared/buttons/circular-icon-button";
import { Box } from "@chakra-ui/react";
import { useOverlay } from "modules/providers/overlay-provider";
import { MODAL_TYPE } from "modules/providers/overlay-provider/overlay-provider";
import UserAvatar from "modules/_shared/user-avatar";
import { useAuth } from "modules/providers/auth-provider";

const UserEditAvatarButton = () => {
  const { me } = useAuth();
  const { openModal } = useOverlay();

  const onEditAvatarClicked = useCallback(() => {
    openModal({ type: MODAL_TYPE.EDIT_USER_AVATAR });
  }, [openModal]);

  if (!me) return null;

  return (
    <Box pos="relative">
      <UserAvatar userId={me.id} size="xl" displayOnlineIndicator={false} />
      <CircularIconButton
        size="sm"
        variant="solid"
        borderColor={colors.white}
        borderWidth={2}
        onClick={onEditAvatarClicked}
        icon={<PencilOutlineIcon boxSize={4} fill={colors.white} />}
        position="absolute"
        aria-label="Edit Avatar"
        right="0"
        top="70px"
      />
    </Box>
  );
};

export default memo(UserEditAvatarButton);
